<div class="container py-5" style="max-width: 560px;">
  <div class="text-center mb-4">
    <h2 class="fw-bold mb-1">Set a new password</h2>
    <div class="text-muted">Use a strong password that you have not used before.</div>
  </div>

  <div class="text-center py-5" *ngIf="validating">
    <div class="spinner-border text-primary"></div>
    <div class="text-muted mt-3">Validating reset link...</div>
  </div>

  <div class="alert alert-danger" *ngIf="error">{{ error }}</div>

  <div class="card shadow-sm border-0" *ngIf="completed">
    <div class="card-body p-4 text-center">
      <h5 class="fw-bold">Password updated</h5>
      <p class="text-muted">All existing sessions have been revoked. Sign in again with your new password.</p>
      <a routerLink="/auth/login" class="btn btn-primary">Go to login</a>
    </div>
  </div>

  <form class="card shadow-sm border-0" [formGroup]="form" (ngSubmit)="submit()"
    *ngIf="!validating && validToken && !completed">
    <div class="card-body p-4">
      <div class="mb-3">
        <label class="form-label">New password</label>
        <input type="password" class="form-control" formControlName="newPassword" autocomplete="new-password"
          [class.is-invalid]="submitted && form.controls.newPassword.invalid" />
        <div class="invalid-feedback">Use at least 8 characters.</div>
        <div class="form-text">Include uppercase, lowercase, a number, and a special character.</div>
      </div>
      <div class="mb-3">
        <label class="form-label">Confirm new password</label>
        <input type="password" class="form-control" formControlName="confirmPassword" autocomplete="new-password"
          [class.is-invalid]="submitted && form.controls.confirmPassword.invalid" />
        <div class="invalid-feedback">Confirm your new password.</div>
      </div>
      <button class="btn btn-primary w-100" type="submit" [disabled]="loading">
        <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
        Reset password
      </button>
    </div>
  </form>
</div>
